// extracted by mini-css-extract-plugin
export default {"pageName":"PageName_pageName__Mb9s7","iconWrapper":"PageName_iconWrapper__w52TT"};